<style scoped>

.about-text {
    font-size: 18px;
    color: #212322;
    text-align: justify;
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 20px;
}

h3 {
    font-family: "Open Sans", sans-serif;
    font-size: 30px;
    font-weight: bold;
}

p {
    font-family: "Inconsolata", monospace;
}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}
.cv_sub {
  font-size: 24px;

}

@media (max-width: 575px) {
  p {
    text-align: left;
    line-height: 1.6;
  }
  br {
   display: block;
   margin: 10px 0;
}
}
</style>

<template>

<div>
    <MenuBar/>
    <b-row class="about-text">
        <b-col md="10">
          <p>Alice Strete (1991, RO/NL) is a cultural worker, artist, cook, and researcher based in Rotterdam. She is a member of <a href="http://varia.zone/">Varia</a> and co-founding member of <a href="https://biobulkbende.org/">Biobulkbende</a> food co-operative.</p>
          <p>For more information/questions/collaboration enquiries, drop her an email at strt [@] riseup [dot] net.
You can also find her on <a href="https://www.instagram.com/alicestrt/" target="_blank">Instagram</a> and <a href="https://post.lurk.org/@alcstrt" target="_blank">Mastodon</a>.
          </p>
<p class="cv_sub">Art and Research </p>
  <p>
  2025, <a href="https://varia.zone/en/rural-technology-rachelle-eerhart.html">Rural tech</a>, radio show with Benjamin Earl and Dani Garcia-Caro, Varia, Rotterdam, NL <br>
  2025, <a href="https://www.garagerotterdam.nl/activiteiten/disaster-cooking/">Meals for Inner Peace Research Center</a>, research and thematic dinner, part of Underdeveloped 4, Garage, Rotterdam, NL<br>
  2025, <a href="https://varia.zone/en/self-medicated-practices-diy.html">Self-Medicated Practices</a>, workshop series and publication with Yoana Buzova, Varia, Rotterdam, NL <br>
  2024, <a href="https://varia.zone/en/whine-dine-decline.html">Whine, Dine and Decline</a>, thematic dinner and discussion on food and climate change with Yoana Buzova, Varia, Rotterdam, NL <br>
  2024, <a href="https://varia.zone/en/common-dirt.html">Common Dirt (Spring Edition)</a> guided tour and discussion with Yoana Buzova and Niek Hilkmann in Varia, Rotterdam, NL <br>
  2023, <a href="https://varia.zone/en/doing-the-dishes-and-then-revolution.html">Doing the Dishes and then Revolution</a>, collective session in Varia, Rotterdam, NL <br>
  2023, <a href="https://varia.zone/en/sometimes-not-available-transfeminist-digital-care-network.html">Sometimes Not Available</a> collective sessions around feminist infrastructures with Cristina Cochior in Varia, Rotterdam, NL <br>
  2023, <a href="https://varia.zone/en/varia-afhaal-chip-shortage.html">Varia Afhaal</a>, collective sessions with Yoana Buzova and Simon Browne, Rotterdam, NL <br>
  2023, <a href="https://www.eventbrite.nl/e/situated-kitchen-ultratranslation-marathon-tickets-602491948637">Situated Kitchen Ultratranslation Marathon</a>, work session part of the Ultradependent Public School, BAK, Utrecht, NL <br>
  2023, <a href="https://www.bakonline.org/program-item/sancochotopia-a-winter-ultrahospitality-mini-garage-school/">Sancochotopia</a>, work session part of the Ultradependent Public School, BAK, Utrecht, NL <br>
  2023, <a href="https://www.domainepublic.net/Now-think-of-a-question-that-is-at-stake-for-you.html">Now Think of a Question that Is at Stake for You</a>, installation and workshop in Constant with Cristina Cochior, Brussels, BE <br>
  2022, <a href="https://qujochoe.org/el-queso/">1/cm2</a>, short film, El Queso group exhibition by qujOchÖ, Linz, AT <br>
  2022, <a href="https://vvvvvvaria.org/archive/2022-07-documenta15-harvesters/">Varia harvest of lumbung.space</a>, publishing experiment, documenta15, Kassel, DE <br>
  2021-2022, <a href="https://varia.zone/en/atnofs-varia.html">A Traversal Network of Feminist Servers</a>, a trans-European series of events on self-hosting, NL RO AT GR BE <br>
  2021, <a href="https://ontheradio.recipes/">Recipes on the Radio</a>, radio show on WORM Radio, Rotterdam, NL<br>
  2021, <a href="http://relearn.be/2021/">Relearn</a>, co-organiser, collective learning experiment and summer school, Rotterdam, NL<br>
  2020-present, <a href="https://fizz.varia.zone/">Fizz Club</a>, a fermentation gathering at Varia, Rotterdam, NL <br>
  2020, <a href="https://a-nourishing-network.radical-openness.org/">A Nourishing Network</a>, publishing project in collaboration with servus.at, Linz, AT<br> 
  2020, <a href="https://feministsearchtools.nl/">Feminist Search Tools</a>, design and development visualisation tool with Aggeliki Diakrousi, NL <br>
  2020, <a href="https://hackersanddesigners.nl/s/Events/p/Intersectional_Search_in_Queer_and_Trans_Archives">Intersectional Search in Queer and Trans Archives</a>, Feminist Search Tool project with Aggeliki Diakrousi, NL <br>

<!-- 2019, <a href="https://www.gaite-lyrique.net/evenement/grrrls-tech-zine-fair">Grrrls Tech Zine Fair</a>, Gaîté Lyrique,
Participated with over/under, Techno/Cyber/Xeno-Feminism, Paris, FR<br> -->
2018, <a href="https://sign2.nl/events/timeline-intervention-happiness-project-alice-strete-angeliki-diakrousi/">The Happiness Project</a>, public intervention, Timeline Gallery, Groningen, NL<br>
  </p>

<p class="cv_sub">Lectures & talks & workshops</p>
  <p>
2025, <a href="https://institutfrancais.sk/fr/podujatie/medzinarodna-konferencia-after-industry/">Self-Governance in Server-Practices</a>, talk and panel discussion with amy pickles, After Industry International Conference, Nová Dubnica and Trenčianske Teplice, SK <br>
2023, 2024 <a href="https://www.hslu.ch/de-ch/design-kunst/studium/interdisziplinaere-module/colabor/modulangebot-2023/co-120/">Situated Infrastructures</a>, guest talk and workshop with Artemis Gryllaki at HSLU, Lucerne, CH <br>
2023, <a href="https://www.dcci.ie/events/artist-led-server-networks/">Artist-Led Server Networks</a>, workshop, Irish Design Week, Manorhamilton, IE <br>
2023, <a href="https://sfpc.study/sessions/spring-23/solidarity-infra">Solidarity Infrastructures</a>, guest talk with Cristina Cochior and Danny Tirthdas van der Kleij, SFPC, New York, US <br>
2022, <a href="https://art-meets.radical-openness.org/program/amro-times/">AMRO Times</a>, work session at AMRO 2022, Linz, AT <br>
2022, <a href="https://art-meets.radical-openness.org/program/hosting-with-the-others/">Hosting with the Others</a>, panel discussion, AMRO, Linz, AT <br>
2021, <a href="https://2021.designweek.melbourne/events/ideas-for-humanity-a-cookbook-for-planetary-health/">A short lecture on cookbooks and other problems</a>, guest talk part of Global Design Studio, UAL, London, UK <br>
2021, <a href="https://hackersanddesigners.nl/s/Summer_Academy_2021/p/Reading_food_with_Relearn_and_Varia">Reading Food</a>, workshop with Santiago Pinol, part of Hackers&Designers Summer Academy 2021, Amsterdam, NL<br>
2021, <a href="https://varia.zone/en/pad-publishing.html">Pad-Publishing</a>, workshop with Manetta Berends, Artemis Gryllaki and Simon Browne, Zine Camp, Rotterdam, NL <br>
2021, <a href="https://libregraphicsmeeting.org/2021/en/presentation15.html">A Nourishing Network</a>, lecture with Manetta Berends, Libre Graphics Meeting, Rennes, FR <br>
2021, Fizz Club talk, Paper ASMR, Rotterdam, NL <br>
2020, <a href="https://beyond-social.org/wiki/index.php/Vulnerable_Publishing_Workshop">Vulnerable Publishing</a>, workshop series with Aggeliki Diakrousi, WDKA, Rotterdam, NL <br>
2020, <a href="https://hackersanddesigners.nl/s/Events/p/Workshop%3A_Repository_of_Feminist_Search_Strategies">Repository of Feminist Search Strategies</a>, Workshop with Hackers&Designers, Read-in, Amsterdam, NL<br>
2019, <a href="https://portfolio.alicestrete.me/unpacking">Unpacking Gender Roles</a>, discussion with Aggeliki Diakrousi and Natasha Berting, Piet Zwart Institute, Rotterdam, NL<br>
2018, <a href="https://gitlab.constantvzw.org/zine-machines">Zine Machines Workshop</a>, SIGN, Spread Zinefest, Groningen, NL<br>
  </p>

<p class="cv_sub"> Exhibitions </p>
  <p>
2025, <a href="https://screensaver.gallery/chaline-bang-ren-loren-britton-alice-strete-col-cristina-cochior-hands-that-hold-the-networks">rosa_diagram</a>, Hands that Hold the Networks collective exhibition, Screensaver Gallery, online <br>
2024-2025, <a href="https://roodkapje.org/anarchief/">Twice Removed</a>, installation, part of Anarchive group exhibition, Roodkapje, Rotterdam, NL <br>
2020, <a href="https://esc.mur.at/en/projekt/cyborg-subjects">Cyborg Subjects</a>, group exhibition, esc kunst medien labor, Graz, AT<br>
2020, <a href="https://sign2.nl/events/timeline-gallery-fear-in-public-space-%E2%80%A8booklaunch-review/">Timeline Gallery Exhibition, Book Launch & Review</a>, Group exhibition, Groningen, NL<br>
2019, <a href="https://project.xpub.nl/is-it-time-to-eat-or-is-there-no-more-time-to-eat/">Is it time to eat, or is there no more time to eat?</a>, Upsetting Settings Graduation Show, Piet Zwart Institute,
Group exhibition, Rotterdam, NL<br>
2018, <a href="https://issue.xpub.nl/06/">XPPL</a>, Interfacing the Law Group Show, Piet Zwart Institute, Rotterdam, NL<br>
2018, <a href="https://issue.xpub.nl/05/">OuNuPo</a> Group show, Piet Zwart Institute, Varia, WORM, Rotterdam, NL<br>
2018, <a href="https://www.tentrotterdam.nl/event/the-temporary-autonomous-bureau-anomalous-institutions/">Temporary Autonomous Bureau</a>, TENT Gallery, Rotterdam Cultural Histories
Group show/exhibition, Rotterdam, NL
  </p>

<p class="cv_sub">Publications</p>
  <p>
2025, Self-Medicated Practices, editor and author, Rotterdam, NL <br>
2024, Self-Organised Spreads, editor and author, Rotterdam, NL <br>
2023, <a href="https://varia.zone/en/atnofs-publication.html">ATNOFS publication</a>, editor and author, Rotterdam, NL <br>
2022, <a href="https://hackersanddesigners.nl/p/First,_Then..._Repeat._Workshop_Scripts_in_Practice">First, Then… Repeat. Workshop Scripts in Practice</a>, ed. Anja Groten, Amsterdam, contributor, NL <br>
2022, <a href="https://art-meets.radical-openness.org/program/amro-times/">AMRO Times</a>, editor and designer, Linz, AT <br>
2020-2021, <a href="https://magiun.alicestrete.me">Magiun Magazine</a>, editor, author, producer, Rotterdam, NL <br>
2020, <a href="https://wellsofknowledge.wdka.nl/">Wells of Knowledge</a>, hybrid publication project commissioned by the WDKA, together with Aggeliki Diakrousi, Rotterdam, NL<br>
2020, <a href="https://code-art.xyz/pdfs/issue0.pdf">Code::Art Journal</a>, contributor, UK<br>
2019, <a href="https://portfolio.alicestrete.me/catalogue">Upsetting Settings Catalogue</a>, editor, author and producer, Rotterdam, NL <br>
2019, <a href="https://portfolio.alicestrete.me/upsetting">Upsetting Settings, Collected Works</a>, editor, author and producer, Rotterdam, NL<br>
2019, <a href="https://portfolio.alicestrete.me/overunder">Over/Under zine</a>, author and designer, Rotterdam, NL<br>
2018, <a href="https://portfolio.alicestrete.me/xeno">Techno/Cyber/Xeno-Feminism Reader</a>, author and designer, Rotterdam, NL<br>
2017, <a href="https://issue.xpub.nl/04/">A Bed, a Chair and a Table</a>, author and editor, Rotterdam, NL
  </p>

<p class="cv_sub">Work</p>
  <p>
2024-2025, Villa Augustus, cook <br>  
2024, Piet Zwart Institute, Guest tutor in Experimental Publishing for <a href="https://issue.xpub.nl/23/">Special Issue 23</a><br>  
2021-2023, Willem de Kooning Academy, Tutor in Autonomous Practices minor, Hacking and Digital Craft<br>
2019-2021, Willem de Kooning Academy, Researcher
Developer of publishing platform <a href="https://beyond-social.org/wiki/index.php/Main_Page">Beyond Social</a> within the
Social Practices minor, workshop facilitator, substitute tutor <br>
2016-2021,
Fairplanet.org, Social Media Manager for a non-profit independent
solution journalism platform focused on human rights and the environment.
</p>
<p class="cv_sub">Education</p>
<p>2017-2019, Rotterdam,
Piet Zwart Institute, Willem de Kooning Academy, MA
Master of Arts in Fine Art and Design: Experimental Publishing <br>
2013-2014, Dublin, Dublin City University, Erasmus Semester Abroad, Communication Studies <br>
2011-2014, Cluj-Napoca, Babes-Bolyai University, Bachelor, Faculty of Political, Administrative and Communication Studies</p>
<p class="cv_sub">Awards/Grants</p>
<p>
  2025, Partial Scholarship, MAD Academy, Copenhagen DK <br>
  2024, Tool Sheds Fellowship as Varia, Het Nieuwe Instituut <br>
  2021-2026, 1 and two-year Activities Programme as Varia, Stimuleringsfonds <br>
  2021, Culture of Solidarity Fund for ATNOFS, from the European Cultural Foundation <br>
  2021, Makersloket Grant, Stichting Droom en Daad <br>
  2020, Temporary Work Contribution Production, Presentation and Research (PPR) from CBK Rotterdam <br>
  2018, Van Beek-Donner Stichting, Awarded the Grada van Beek-Donner Scholarship</p>

        </b-col>
    </b-row>
<b-row class="about-text">
  <b-col md="10">
    <p>
    This website is built using BootstrapVue by Alice Strete.
</p>
  </b-col>
</b-row>



</div>

</template>

<script>

import MenuBar from './MenuBar'
export default {
    name: 'AboutPage',
    components: {
        MenuBar
    }
}

</script>
